import { types } from 'mobx-state-tree';
import * as views from './scrapersStoreViews';
import * as actions from './scrapersStoreActions';

const ScrapersStore = types
  .model('ScrapersStore', {
    // Plain frozen rows from GET /cms/scrapers — no editing happens on the
    // objects themselves, so a full MST model is unnecessary.
    scrapers: types.optional(types.array(types.frozen()), []),
    providers: types.optional(types.array(types.string), []),
    service: types.optional(types.frozen(), null),
    activeRun: types.optional(types.frozen(), null),
    runningIntegrationId: types.optional(types.maybeNull(types.number), null),
    loading: types.optional(types.boolean, false),
    updating: types.optional(types.boolean, false)
  })
  .views(views.scrapersStoreViews)
  .actions(actions.scrapersStoreActions);

export default ScrapersStore;
